import { render } from "./UeberDieApp.vue?vue&type=template&id=1aa86f42"
const script = {}

import "./UeberDieApp.vue?vue&type=style&index=0&id=1aa86f42&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__